import { AlphabetCollectionsDraftApi, useAPIAction, } from "melco-shared-logic";

export const useAddFontCollection = () =>
  useAPIAction(
    AlphabetCollectionsDraftApi,
    async (api) => {
      const data = await api.userAlphabetCollectionsCreateDraft({
        sharedserviceMelcoModelsAddAlphabetCollection: {
          alphabet_list: [],
        },
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "font_collections.actions.add",
    }
  );
